import { Component, OnInit, ViewChild } from '@angular/core';
import { Apollo } from 'apollo-angular';
import {MatPaginator} from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import moment from 'moment';

import { Workbook } from 'exceljs';
import * as fs from 'file-saver';

//SERVICIOS
import { DocumentoService } from './../../../../services/documento.service';
import { DetalleService } from './../../../../services/detalle.service';
import { ConfirmacionService } from './../../../../services/confirmacion.service';
import { ValidacionComponent } from '../../validacion/validacion.component';

@Component({
  selector: 'app-tabla-proximos-caducar',
  templateUrl: './tabla-proximos-caducar.component.html',
  styleUrls: ['./tabla-proximos-caducar.component.scss']
})
export class TablaProximosCaducarComponent implements OnInit {

  public documentos: any[] = []
  public documentosProximos: any[] = []
  public loading?: Boolean
  public tableColumns?: String[]
  public title?: String
  public dataSource?: any
  public filterValue?: string

  @ViewChild(MatPaginator) paginator?: MatPaginator;
  @ViewChild(MatSort) sort?: MatSort;

  constructor(private apollo: Apollo, private documentoService: DocumentoService, private detalleService: DetalleService, private confirmacionService: ConfirmacionService) { 
    this.tableColumns = [/* 'id', */ 'nombre', 'dueñoDocumento', 'indicador', 'fechaCaducidad']
  }

  ngOnInit(): void {
    this.getAllDocumentosValidados()
    this.setDocumentoProximoCaduca()
  }

  exportAsExcel() {
    
    let workbook = new Workbook();
    let worksheet = workbook.addWorksheet("Documentos Próximos a Caducar");
    let header = ["Id", "Nombre", "Contratista", "Centro", "Gestor", "Transportista", "Fecha Caducidad"]
    let headerRow = worksheet.addRow(header);

    for (let documento of this.documentosProximos) {
      let temp = []
    
      // MAPEADO //
      temp.push(documento["id"])
      temp.push(documento["nombre"])
      temp.push(documento["contratista"] ?  documento["contratista"]["nombreComercial"]: '')
      temp.push(documento["centro"] ?  documento["centro"]["nombre"]: '')
      temp.push(documento["gestor"] ?  documento["gestor"]["nombre"]: '')
      temp.push(documento["transportista"] ?  documento["transportista"]["nombre"]: '')
      temp.push(documento["fechaCaducidad"]? moment(documento["fechaCaducidad"]).format('DD/MM/YYYY') : '')
              
      worksheet.addRow(temp)
     
    }

    let fname = "Documentos Próximos a Caducar"

    workbook.xlsx.writeBuffer().then((data) => {

      let blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      fs.saveAs(blob, fname + '-' + new Date().valueOf() + '.xlsx');
    });
  }


  getAllDocumentosValidados(){
    this.apollo.watchQuery<any>({
      query: this.documentoService.getAllDocumentosValidados(),

    })
      .valueChanges
      .subscribe(({data, loading, errors}) => {
        this.loading = loading
        this.documentos = data.documentos
        this.documentos.map((documento) => {
          if(documento.proximoCaduca) {
            this.documentosProximos.push(documento)
            console.log(documento.fechaCaducidad)
          }
        })
        this.setDataTableOptions()
      })
  }

  setDocumentoProximoCaduca(){
    this.documentos.map((documento) => {
      if(documento.fechaCaducidad <= this.documentoService.getNextMonth() && documento.fechaCaducidad > this.documentoService.getActualDate()) {
        this.updateDocumentoToProximoCaduca(documento.id)
      }
    })
  }

  updateDocumentoToProximoCaduca(id: string){
    this.apollo.mutate({
      mutation: this.documentoService.updateDocumentoById(),
      variables: {
        "input": {
          "where": {
            "id": id
          },
          "data": {
            "proximoCaduca": true
          }
        }    
      }
    })
      .subscribe(({data, errors}) => {
        console.log("EDITADO", data)
      }, (error) => {
        console.log('aaaaa',error)
      })
  }

  setDataTableOptions(){
    this.dataSource = new MatTableDataSource(this.documentosProximos)
    this.dataSource.paginator = this.paginator;   
    this.dataSource.sort = this.sort;
    this.dataSource.sortingDataAccessor = (item: any, property: any) => {
      return this.sortingData(item, property)
    };
    this.dataSource.filterPredicate = (data: any, filter: string) => {
      return this.filterPredicate(data, filter)
    }
  }

  sortingData(item: any, property: any){
    let documentOwner;
    if(item.gestor){
      documentOwner = item.gestor.nombre
    } else if(item.transportista){
      documentOwner = item.transportista.nombre
    } else if(item.contratista){
      documentOwner = item.contratista.nombreComercial
    }

    switch(property) {
      case 'dueñoDocumento': return documentOwner;
      default: return item[property];
    }
  }

  applyFilter(e: any){
    this.filterValue = e.target.value
    this.dataSource.filter = this.filterValue?.trim().toLocaleLowerCase();
  }

  filterPredicate(data: any, filter: string){
    const dateExpiredFormatted = moment(data.fechaCaducidad).format('DD/MM/YYYY');
    return data.id.toLocaleLowerCase().includes(filter) ||
            data.nombre.toLocaleLowerCase().includes(filter) ||
            data.contratista?.nombreComercial.toLocaleLowerCase().includes(filter) ||
            data.gestor?.nombre.toLocaleLowerCase().includes(filter) ||
            data.transportista?.nombre.toLocaleLowerCase().includes(filter) ||
            data.centro?.nombre.toLocaleLowerCase().includes(filter) ||
            dateExpiredFormatted.includes(filter);
  }

  openValidation(id: string){
    const options= {
      id: id,
    }
    this.detalleService.openTest(options, ValidacionComponent);
    this.setComentariosLeidos(id)
  }

  handleClick(id: String){
    const options = {
      cancelText: 'Cancelar',
      confirmText: 'Eliminar'
    };
    this.confirmacionService.open(options);
      
    this.confirmacionService.confirmed().subscribe(confirmed => {
      if (confirmed) {
        this.deleteDocumentoById(id)
      }
      });
  }

  deleteDocumentoById(id: String){
    this.apollo.mutate({
      mutation: this.documentoService.deleteDocumentoById(),
      variables: {
        "input": {
          "where": {
            "id": id
          },
        }
      }
    })
      .subscribe(({data}) => {
        console.log('BORRADO', {data})
      }, (error) => {
        console.log(error)
      })
  }

  setComentariosLeidos(id: string){
    this.documentoService.setComentariosLeidos(id).subscribe(({data, errors}) => {
      console.log("EDITADO", data, errors)
    }, (error) => {
      console.log(error)
    })
  }

}
